import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Cliente.types';
import { ICliente, IEstadisticaVentas, IEstadisticaArticulos } from './Cliente.lib';
import moment from 'moment';
import { isNumber } from 'util';
import { Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class Cliente extends ICliente
{

    public static async create ( id: number ): Promise<Cliente>
    {
        let o = new Cliente();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/clientes';
    protected async find (): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${ this.Route }/${ this.Id }`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find ( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Cliente>; Error?: boolean; }>
    {

        let a: Array<Cliente> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/clientes` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Cliente( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save (): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${ this.Route }/${ this.Id }`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${ this.Route }`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del (): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${ this.Route }/${ this.Id }`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async cargarVentas ( mes: number, ano: number ): Promise<IEstadisticaVentas[]>
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.params.cliente = this.Id;
                req.params.mes = mes;
                req.params.ano = ano;
                req.path = `/estadisticas/ventas/cliente`;
                if ( await req.get() )
                {
                    return req.data.ventas.map( ( x: any ) => new EstadisticaVentas( x ) );
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return [];
    }

    public static async SubirPadron ( archivo: File, provincia: 'buenosaires' | 'caba' ): Promise<boolean>
    {
        try
        {
            let request = new apiRequest( `/padrones/iibb/${ provincia }` );
            request.timeOut = 1000000;
            request.useformData = true;
            request.formData.append( 'file', archivo );
            if ( await request.post() )
            {
                return true;
            }

        } catch ( e )
        {
            Log( e );
        }

    }
}

export class EstadisticaVentas extends IEstadisticaVentas
{

    public static async create ( id: Cliente, mes: number, ano: number ): Promise<EstadisticaVentas>
    {
        let o = new EstadisticaVentas();
        o.Cliente = id;
        o.Mes = mes;
        o.Ano = ano;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    public static async actual ( cliente: Cliente ): Promise<EstadisticaVentas>
    {
        let o = new EstadisticaVentas();
        if ( moment().getDay() < 7 )
        {
            o.Mes = moment().add( -1, 'month' ).getMonth();
            o.Ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            o.Mes = moment().getMonth();
            o.Ano = moment().getYear();
        }

        o.Cliente = cliente;
        const cta = Cuenta.toTipo( o.Cliente.Id )
        o.esMercadoLibre = cta.esMl && cta.Cliente == o.Cliente.Id;

        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    protected Route: string = '/estadisticas/ventas/cliente';
    protected async find (): Promise<boolean>
    {
        this.Existe = false;
        let request = new apiRequest();
        request.params.cliente = this.Cliente.Id;
        request.params.mes = this.Mes;
        request.params.ano = this.Ano;
        request.path = `${ this.Route }`;
        if ( await request.get() )
        {
            this.Json = request.data.ventas[0];
            this.set();
        }
        return this.Existe;
    }

    public static async find ( params: any ): Promise<EstadisticaVentas[]>
    {

        let request = new apiRequest();

        if ( params )
            request.params = params;

        request.path = `/estadisticas/ventas/cliente`;
        if ( await request.get() )
        {
            return request.data.ventas.map( ( x: any ) => new EstadisticaVentas( x ) );

        }
        return [];
    }

    public static async actuales ( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<EstadisticaVentas>; Error?: boolean; }>
    {

        let a: Array<EstadisticaVentas> = [];
        let paginacion: Paginacion = new Paginacion();


        let request = new apiRequest();
        request.path = `/estadisticas/ventas/clientes`;
        if ( params )
            request.params = params;
        if ( moment().getDay() < 7 )
        {
            request.params.mes = moment().add( -1, 'month' ).getMonth();
            request.params.ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            request.params.mes = moment().getMonth();
            request.params.ano = moment().getYear();
        }

        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new EstadisticaVentas( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }



}


export class EstadisticaArticulos extends IEstadisticaArticulos
{

    public static async create ( id: number, mes: number, ano: number ): Promise<EstadisticaArticulos>
    {
        let o = new EstadisticaArticulos();
        o.Cliente = id;
        o.Mes = mes;
        o.Ano = ano;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    public static async actual ( cliente: Cliente ): Promise<EstadisticaArticulos>
    {
        let o = new EstadisticaArticulos();
        if ( moment().getDay() < 3 )
        {
            o.Mes = moment().add( -1, 'month' ).getMonth();
            o.Ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            o.Mes = moment().getMonth();
            o.Ano = moment().getYear();
        }

        o.Cliente = cliente.Id;

        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    protected Route: string = '/estadisticas/ventas/cliente';
    protected async find (): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.params.cliente = this.Cliente;
        request.params.mes = this.Mes;
        request.params.ano = this.Ano;
        request.path = `${ this.Route }`;
        if ( await request.get() )
        {
            this.Json = request.data.ventas[0];
            this.set();
        }
        return this.Existe;
    }


    public static async find ( params: any ): Promise<EstadisticaArticulos[]>
    {

        let request = new apiRequest();

        if ( params )
            request.params = params;

        request.path = `/estadisticas/ventas/cliente/articulos`;
        if ( await request.get() )
        {
            return request.data.map( ( x: any ) => new EstadisticaArticulos( x ) );

        }
        return [];
    }



}